// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { QueryGroupCondition_abstract } from './../../abstract/SagaBase/Objects/QueryGroupCondition_abstract';
export class QueryGroupCondition extends QueryGroupCondition_abstract {}
